/** 神耀能量在各层数时激活的重生之翼魂印效果。 */
export const 神耀能量效果列表 = [
    {
        threshold: 1,
        text: "受到的攻击伤害减少 10% × 当前层数",
    },
    {
        threshold: 2,
        text: "免疫异常状态，不受能力下降效果影响",
    },
    {
        threshold: 3,
        text: "回合结束时恢复最大体力的 1/3",
    },
    {
        threshold: 4,
        text: "免疫固定伤害，并在回合结束时将其等量反馈给对手",
    },
    {
        threshold: 5,
        text: "所有技能先制额外 +1",
    },
    {
        threshold: 6,
        text: "所有技能威力提升 60%",
    },
] as const;

/**
 * 神耀能量击败奖励，供本模块相关规则使用。
 */
export const 神耀能量击败奖励 =
    "击败对手后消耗当前全部神耀能量，每消耗 1 层使下 1 回合先制 +1，并吸取对手最大体力的 8%";

/**
 * 获取神耀能量已激活效果：执行对应的领域操作。
 * @param stacks stacks参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 获取神耀能量已激活效果(stacks: number) {
    /**
     * normalizedStacks，供本模块相关规则使用。
     */
    const normalizedStacks = Math.max(0, Math.floor(stacks));
    return 神耀能量效果列表.filter(
        (effect) => effect.threshold <= normalizedStacks,
    );
}
